import type { Error as GrpcError } from '@vpn-tg/vue-client-grpc/pkg/error/error'
import { tGlobal } from '@/plugins/i18n'

/**
 * Текст ошибки для UI: сначала сообщение с бэка, иначе i18n-заглушка.
 *
 * @param fallbackKey - ключ из locales.*.errors (например errors.signInFailed)
 */
export function grpcErrorMessage(
  error: Pick<GrpcError, 'message' | 'systemMessage'> | undefined | null,
  fallbackKey: string,
): string {
  const fromBackend = error?.message?.trim() || error?.systemMessage?.trim()
  return fromBackend || tGlobal(fallbackKey)
}
